export default __webpack_public_path__ + "static/media/download_underline.3745faf3.svg";